import { DrawingToolHelpers } from "../../../helpers/drawing-tool-helpers";
import { IComponent } from "../../component.interface";
import { IDrawingTool } from "../drawing-tool.interface";
import { DrawingToolsManager } from "../drawing-tools.manager";

export class ParallelChannelComponent implements IComponent, IDrawingTool {
    public id = '';

    public annotation: any = null;
    private drawingToolManager: DrawingToolsManager;

    constructor(drawingToolManager: DrawingToolsManager, id: string) {
        this.drawingToolManager = drawingToolManager;
        this.id = id;
    }

    public static syncCreate(drawingToolManager: DrawingToolsManager, annotationOptions: any): ParallelChannelComponent {
        const chart: any = drawingToolManager.base.tiChartSeries.highStockChart;
        
        annotationOptions.typeOptions.points[0].x = DrawingToolHelpers.calculateXPosition(
            annotationOptions.typeOptions.points[0].actualXValue,
            annotationOptions.typeOptions.points[0].actualStartTimeT,
            drawingToolManager);

        annotationOptions.typeOptions.points[1].x = DrawingToolHelpers.calculateXPosition(
            annotationOptions.typeOptions.points[1].actualXValue,
            annotationOptions.typeOptions.points[1].actualStartTimeT,
            drawingToolManager);
            
        const component = new ParallelChannelComponent(drawingToolManager, annotationOptions.id);
        const addedNewAnnotation: any = chart.addAnnotation(annotationOptions);

        drawingToolManager.updateAnnotationStyles(addedNewAnnotation, annotationOptions, false);
        component.annotation = addedNewAnnotation;
        return component;
    }

    public static create(drawingToolManager: DrawingToolsManager, event: any): ParallelChannelComponent {
        const component = new ParallelChannelComponent(drawingToolManager, event.options.id);
        component.annotation = event;
        return component;
    }

    public syncUpdate(annotationOptions: any) {

    }

    public getMetaData(): any {
        const firstPoint = this.annotation.options.typeOptions.points[0];
        const actualFirstPosition = DrawingToolHelpers.getActualStartTimePosition(firstPoint, this.drawingToolManager);

        const secondPoint = this.annotation.options.typeOptions.points[1];
        const actualSecondPosition = DrawingToolHelpers.getActualStartTimePosition(secondPoint, this.drawingToolManager);

        return {
            id: this.id,
            langKey: "parallelChannel",
            type: 'tunnel', // options type
            typeOptions: {
                xAxis: this.annotation.options.typeOptions.xAxis,
                yAxis: this.annotation.options.typeOptions.yAxis,
                background: this.annotation.userOptions.typeOptions.background,
                line: this.annotation.userOptions.typeOptions.line,
                height: this.annotation.userOptions.typeOptions.height,
                points: [{
                    x: this.annotation.options.typeOptions.points[0].x,
                    
                    actualStartTimeT: actualFirstPosition?.actualStartTimeT,
                    actualXValue: actualFirstPosition?.actualXValue,

                    xAxis: this.annotation.options.typeOptions.points[0].xAxis,
                    y: this.annotation.options.typeOptions.points[0].y,
                    yAxis: this.annotation.options.typeOptions.points[0].yAxis,
                }, {
                    x: this.annotation.options.typeOptions.points[1].x,
                    
                    actualStartTimeT: actualSecondPosition?.actualStartTimeT,
                    actualXValue: actualSecondPosition?.actualXValue,

                    xAxis: this.annotation.options.typeOptions.points[1].xAxis,
                    y: this.annotation.options.typeOptions.points[1].y,
                    yAxis: this.annotation.options.typeOptions.points[1].yAxis,
                }]   
            }
        };
    }
}